import React, { useEffect, useState, useRef, useContext } from "react";
import styled from "styled-components";
import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import "rsuite/dist/rsuite.css";
import DutyDayScheduleListBody from "../components/DataList/DutyDayScheduleListBody";
import DutyMonthScheduleListBody from "../components/DataList/DutyMonthScheduleListBody";
import { useQuery } from "react-query";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import style from "../style/DutySchedule.module.scss";
import UploadExcel from "../components/UploadExcel";
import FakeApiClient from "../libraries/FakeApiClient";
import apiClient from "../libraries/ApiClient";
import Logger from "../libraries/Logger";
import dayjs from "dayjs";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 95%;
  height: calc(100% - 50px);
  color: #252525;
  position: relative;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .table {
    width: 100%;
    max-height: calc(100% - 246px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  @media (max-width: 1200px) {
    .table {
      max-height: 100%;
      overflow-y: visible;
    }
    .pagination {
      position: static;
    }
  }
`;

function DutySchedule({ lineUserId }) {
  const navigate = useNavigate();
  const { myAuth } = useContext(AuthContext);
  const isAdmin = myAuth.IsAdmin;
  const permission = myAuth.AccountPermission;
  //console.log(isAdmin);
  const [selfIdentities, setSelfIdentities] = useState([]);

  useEffect(() => {
    setSelfIdentities(JSON.parse(localStorage.getItem("auth"))?.SelfIdentities);
    // if (!isAdmin) {
    //   alert("您無此權限，為您轉到轉診清單頁");
    //   navigate("/ReferralDataList");
    // }
    // if (permission != 1) {
    //   alert("您無此權限，為您轉到轉診清單頁");
    //   navigate("/ReferralDataList");
    // }

    const token = JSON.parse(localStorage.getItem("auth"))?.Token;
    const version = import.meta.env.VITE_VERSION;
    const accountRowId = JSON.parse(localStorage.getItem("auth"))?.AccountRowId;
    const time = dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss");
    if (token === undefined) {
      navigate("/Login");
    }

    apiClient.logOfActionEnterPage(location.pathname, "EnterPage", {
      token,
      lineUserId,
      accountRowId,
      time,
      version,
    });
  }, []);
  const { getValues, control } = useForm({
    defaultValues: {
      basic: "",
      case: [],
      date: [],
      transfer: [],
      open: false,
    },
  });

  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [nowPageNumber, setNowPageNumber] = useState(1);

  const [tab, setTab] = useState("Day");

  const [dateTime, setDateTime] = useState(new Date());
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState(2023);
  const [day, setDay] = useState(10);

  const [excelFile, setExcelFile] = useState(null);

  useEffect(() => {
    setMonth(dateTime.getMonth() + 1);
    setYear(dateTime.getFullYear());
    setDay(dateTime.getDate());
  }, []);

  const handlePageChange = (event, value) => {
    setNowPageNumber(value);
  };

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (JSON.parse(localStorage.getItem("auth")) === null || token === null) {
      navigate("/Login");
    }
  }, []);

  const sendDateData = async ({ queryKey }) => {
    //console.log(queryKey);
    const data = {
      Data: {
        Tab: queryKey[5],
        Year: queryKey[2],
        Month: queryKey[3],
        Day: queryKey[4],
      },
    };
    //Logger.LogOfInfoWithIdentity("data=", data);

    const isFake = import.meta.env.VITE_FAKE_MODE;
    if (isFake === "false") {
      const result = await apiClient.postAes(
        "api/shift/GetDutyShift/Security",
        data
      );
      // console.log(result);
      return result?.data?.Data;
    }
  };

  const { data, refetch, isLoading } = useQuery(
    ["sendDateData", token, year, month, day, tab],
    sendDateData,
    { refetchOnWindowFocus: false }
  );
  //console.log(data);

  const MonthDel = () => {
    if (month === 1) {
      setMonth(12);
      setYear(year - 1);
      setDateTime(new Date(year - 1 + "-" + 12 + "-" + 1));
    } else {
      setMonth(month - 1);
      setDateTime(new Date(year + "-" + (month - 1) + "-" + 1));
    }
    refetch;
  };
  const MonthAdd = () => {
    if (month === 12) {
      setMonth(1);
      setYear(year + 1);
      setDateTime(new Date(year + 1 + "-" + 1 + "-" + 1));
    } else {
      setMonth(month + 1);
      setDateTime(new Date(year + "-" + (month + 1) + "-" + 1));
    }
    refetch;
  };

  const DateDel = () => {
    dateTime.setDate(dateTime.getDate() - 1);
    setDateTime(dateTime);
    setMonth(dateTime.getMonth() + 1);
    setYear(dateTime.getFullYear());
    setDay(dateTime.getDate());

    refetch;
  };
  const DateAdd = () => {
    dateTime.setDate(dateTime.getDate() + 1);
    setDateTime(dateTime);
    setMonth(dateTime.getMonth() + 1);
    setYear(dateTime.getFullYear());
    setDay(dateTime.getDate());

    refetch;
  };

  const handleChange = (e) => {
    // console.log(e.target.value);
    setTab(e.target.value);

    setMonth(new Date().getMonth() + 1);
    setYear(new Date().getFullYear());
    if (e.target.value == "month") {
      setDateTime(
        new Date(
          new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + 1
        )
      );
      setDay(1);
    } else {
      setDateTime(new Date());
      setDay(new Date().getDate());
    }
    refetch;
  };

  if (isLoading) {
    return <h1>Loading...</h1>;
  }

  return (
    <Container isOpen={open}>
      <div className={style.top}>
        <div className={style.duty_month}>
          <ToggleButtonGroup
            color="primary"
            value={tab}
            exclusive
            onChange={handleChange}
            aria-label="Platform"
          >
            <ToggleButton value="Day">當日值班</ToggleButton>
            <ToggleButton value="Month">當月值班</ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>

      <div className={style.duty_info}>
        <div className={style.duty_calender}>
          <div className={style.duty}>
            <div className={style.duty_title}>取栓值班醫師</div>
          </div>
          {tab == "Day" ? (
            <div className={style.duty_day}>
              <div className={style.duty_day_left}>
                <a className={style.day_change}>
                  <i className="fa-solid fa-chevron-left" onClick={DateDel}></i>
                </a>
                <div className={style.day_info}>
                  <div className={style.calendar_full}>
                    <div className={style.calendar_top}>
                      <div className={style.weekday}>
                        {dateTime.toLocaleString("zh-tw", { weekday: "long" })}
                      </div>
                    </div>
                    <div className={style.calendar_bottom}>
                      <div className={style.date}>
                        <div className={style.date_month}>
                          {year}年{month}月
                        </div>
                        <div className={style.date_day}>{day}</div>
                      </div>{" "}
                    </div>
                  </div>
                </div>
                <a className={style.day_change}>
                  <i
                    className="fa-solid fa-chevron-right"
                    onClick={DateAdd}
                  ></i>
                </a>
              </div>
              <div className={style.duty_day_right}>
                <DutyDayScheduleListBody data={data} />
              </div>
            </div>
          ) : (
            ""
          )}

          {tab == "Month" ? (
            <div>
              <div className={style.duty_month}>
                <a className={style.month_change}>
                  <i
                    className="fa-solid fa-chevron-left"
                    onClick={MonthDel}
                  ></i>
                </a>
                <div className={style.month_info}>
                  <span className={style.year}>{year}年</span>
                  {month > 9 ? (
                    <span className={style.month}>{month}月</span>
                  ) : (
                    <span className={style.month}>0{month}月</span>
                  )}
                </div>
                <a className={style.month_change}>
                  <i
                    className="fa-solid fa-chevron-right"
                    onClick={MonthAdd}
                  ></i>
                </a>
              </div>

              <DutyMonthScheduleListBody data={data} />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      {/* <DutyMonthScheduleListBody data={data} /> */}
    </Container>
  );
}

export default DutySchedule;
